import { render, staticRenderFns } from "./commonIndex.vue?vue&type=template&id=08953170&scoped=true&"
import script from "./commonIndex.vue?vue&type=script&lang=js&"
export * from "./commonIndex.vue?vue&type=script&lang=js&"
import style0 from "./commonIndex.vue?vue&type=style&index=0&lang=css&"
import style1 from "./commonIndex.vue?vue&type=style&index=1&id=08953170&lang=less&scoped=true&"
import style2 from "./commonIndex.vue?vue&type=style&index=2&id=08953170&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08953170",
  null
  
)

export default component.exports